module.exports = __webpack_public_path__ + "step5_M2F_kanai_bridal.fb28147a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_M2F_kanai_bridal.jpg
// module id = V9Bz
// module chunks = 0